import React from 'react';
import FeatureSection from "../featureSection/featureSection";
import {graphql, useStaticQuery} from "gatsby";
import {getImage} from "gatsby-plugin-image";
import RewardTag from '../../../images/homepage/feature/icon/reward-tag.svg'
import Speaker from '@images/homepage/feature/icon/speaker.svg'
import Chart from '@images/homepage/feature/icon/chart.svg'

function FeatureSectionWrapper() {
  const query = useStaticQuery(graphql`{
    allFile(filter: {sourceInstanceName: {eq: "features"}}) {
      edges {
        node {
          id
          name
          childImageSharp {
            gatsbyImageData (
              quality: 100,
              outputPixelDensities: 2,
              placeholder: NONE,
              backgroundColor: "#00092d",
              width: 575
            )
          }
        }
      }
    }
  }`)

  let templateImages = query.allFile.edges.map((item) => (
    getImage(item.node.childImageSharp.gatsbyImageData)
  ))

  const data = [
    {
      "icon": RewardTag,
      "title": 'Automated appointment booking and payment processing',
      "desc": 'Encourage early booking with the personalized booking environment created by Trafft. Our appointment booking software easily integrates with your website, making it a stress-free online booking experience for your client.',
      "alt": 'Appointment details in Trafft'
    },
    {
      "icon": Speaker,
      "title": 'Appointment reminders for all participants',
      "desc": 'No more forgotten appointments. Our online scheduling software will automatically send SMS and email reminders and follow ups so that both the staff and the customers receive appointment reminders and updates.',
      "alt": 'An email reminder from Trafft for a coaching session'
    },
    {
      "icon": Chart,
      "title": 'Monitor your business performance',
      "desc": 'The Trafft online booking system helps you increase sales by providing important business reports and dashboards to help you track the performance of your business through vital KPIs and statistics.',
      "alt": 'Trafft dashboard that shows business performance'
    }
  ];

  return (
    <FeatureSection
      templateImages={templateImages}
      title='Watch your business evolve'
      description=' Offer on-site or virtual appointments, manage staff and services, process payments, send invoices and reminders - all in one small business scheduling software.'
      data={data}
    />
  );
}

export default FeatureSectionWrapper;